import React from 'react';
import cn from 'clsx';
import { formatToRub } from 'utils/format';
import { Typography } from '../../typography';
import {
  discountPlate,
  discountPlateImage,
  discountPlateSizeMap,
  discountPlateTextSizeMap,
  discountPrice,
  discountPriceWrapper,
} from './discount-price-styles';
import { DiscountPlateSize } from './discount-price-types';

type DiscountPriceProps = {
  className?: string;
  discount?: number;
  price: number;
  prefix?: string;
  size: DiscountPlateSize;
  showDiscountPlate: boolean;
}

export const DiscountPrice: React.FC<DiscountPriceProps> = ({
  className, discount, price, prefix, size, showDiscountPlate
}) => (
  <div className={cn(discountPriceWrapper, className)}>
    {(discount && showDiscountPlate) && (
      <div className={cn(discountPlate, discountPlateSizeMap[size])}>
        <img
          className={cn(discountPlateImage, discountPlateSizeMap[size])}
          src="https://cdn.lemanapro.ru/lmru/image/upload/fudzi/elbrus/images/landings/common/discount/discount-plate.png/discount-plate.png"
        />
        <Typography
          className={cn(discountPlateTextSizeMap[size])}
          variant="overline"
          color="text-primary-invert"
        >
          -{discount}%
        </Typography>
      </div>
    )}

    <Typography className={discountPrice} variant="caption_accent">
      {prefix && `${prefix}${' '}`}
      {formatToRub(price)}{' '}₽
    </Typography>
  </div>
)
